import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"
import PaidPolicyComponent from "../components/PaidPolicyComponent"

const PaidPolicyPage = () => {
    return (
        <>
            <HeaderComponent/>
            <div className="bg-white">
            <PaidPolicyComponent/>
            </div>
            <FooterComponent/>
        </>
    )
}

export default PaidPolicyPage